import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";

import BroadCast from "../broadcast/broadcastMain";
import HelpSection from "../help-tutorial/help";
import HomeSection from "../home/home";
import CreateMain from "../leases/createProperty/createMain";
import DetailLeaseMain from "../leases/leaseDetail/main";
import LeasesSection from "../leases/leases";
import LogoutSection from "../logout";
import MaintainanceSection from "../maintenance/maintainance";
import DetailMain from "../maintenance/maintanance-detail/detailMain";
import Notification from "../notification/main";
import CompanyInfo from "../profile-complete/company-information/company-info";
import PersonalInfo from "../profile-complete/personal-information/personal-info";
import PropertySection from "../properties/properties";
import MainSection from "../properties/property-detail/main";
import ReportsSection from "../reports/reports";
import TenantsSection from "../tenants/tenants";
import MainTenantSection from "../tenants/tenantsDetail/main";
import UnitsSection from "../units/units";
import ViewProfile from "../view-profile/profile";
import MainPayment from "../payment/main";

import BaseUrl from "../../../constants/BaseUrl";

import * as LeaseDataAction from "../../../store/actions/lease/LeaseAction";

const RightSection = ({ activeComponent, setActiveComponent, showChatBot }) => {
  const navigate = useNavigate();
  const [recordId, setRecordId] = useState();
  const [propertyId, setPropertyId] = useState();
  const [showDetail, setShowDetail] = useState("");
  const [recordLeaseId, setLeaseRecordId] = useState();
  const [seletedTenant, setSelectedTenant] = useState();
  const { loginSuccess } = useSelector((state) => state.auth);

  const dispatch = useDispatch();

  const CheckCurrentShift = () => {
    const myHeaders = new Headers();
    myHeaders.append("Authorization", `Bearer ${loginSuccess?.token}`);

    const requestOptions = {
      method: "GET",
      headers: myHeaders,
      redirect: "follow",
    };

    fetch(`${BaseUrl}api/support/checkCurrentActiveSession`, requestOptions)
      .then((response) => response.json())
      .then((result) => {
        if (result.status === "success") {
          showChatBot(true);
        } else {
          showChatBot(false);
        }
      })
      .catch((error) => console.error(error));
  };

  useEffect(() => {
    const interval = setInterval(() => {
      CheckCurrentShift();
    }, 5000);

    return () => clearInterval(interval);
  }, []);

  const toggleDetailProperty = (id) => {
    setPropertyId(id);
    setActiveComponent("PropertyDetails"); // State toggle karein
  };

  const toggleTenantDetail = (tenant) => {
    setSelectedTenant(tenant);
    setActiveComponent("tenantdetail");
  };

  // Function to show the Notification component
  const handleShowNotification = () => {
    setActiveComponent("Notifications"); // Set activeComponent to "Notification"
  };

  const onHandleLease = () => {
    setActiveComponent("Leases"); // Set activeComponent to "Notification"
  };

  const toggleDetailMaintain = () => {
    setActiveComponent("MaintainanceDetails");
  };

  const handleShowProperty = () => {
    setActiveComponent("Properties");
  };

  const toggleCreate = () => {
    setActiveComponent("createLease");
  };

  // Function to show the Home component
  const handleShowHome = () => {
    setActiveComponent("Home"); // Set activeComponent to "Home"
  };

  const handleShowMaintainance = () => {
    setActiveComponent("Maintenance");
  };

  const handleShowProfiles = () => {
    setActiveComponent("Profile");
  };

  const handleShowProfile = (item) => {
    if (item === "Password") {
      navigate("/change-password");
    } else {
      setActiveComponent(item);
    }
  };

  const toggleLeaseDetail = (status, id) => {
    setShowDetail(status);
    setLeaseRecordId(id);
    setActiveComponent("detailLease"); // State toggle karein
  };

  const onHandleTenantList = () => {
    setActiveComponent("Tenants");
  };

  // If the activeComponent is "Notification", show the Notification component
  if (activeComponent === "Notifications") {
    return <Notification onBack={handleShowHome} />;
  }

  // Show the HomeSection component if activeComponent is "Home"
  if (activeComponent === "Home") {
    return (
      <HomeSection
        onNotificationClick={handleShowNotification}
        onMaintainancePage={handleShowMaintainance}
        onViewDetailsMaintain={(item) => {
          setRecordId(item);
          toggleDetailMaintain(item);
        }}
        onViewDetailProperty={(id) => {
          toggleDetailProperty(id);
        }}
        onViewPropertyPage={handleShowProperty}
        onDetailsTenant={toggleTenantDetail}
        onTenantList={onHandleTenantList}
        onLeaseTable={onHandleLease}
        onNavigateToPayments={() => setActiveComponent("Payment")}
      />
    );
  }

  // Handle other sections
  if (activeComponent === "Tenants")
    return (
      <TenantsSection
        toggleMaintainanceTable={handleShowMaintainance}
        onTriggerCard={(item) => {
          handleShowProfile(item);
        }}
        onBack={handleShowHome}
      />
    );
  if (activeComponent === "Properties")
    return (
      <PropertySection
        toggleMaintainanceTable={handleShowMaintainance}
        onBackHome={handleShowHome}
        onTenantTable={onHandleTenantList}
      />
    );
  if (activeComponent === "Units") return <UnitsSection />;
  if (activeComponent === "Maintenance") return <MaintainanceSection />;
  if (activeComponent === "Leases")
    return (
      <LeasesSection
        toggleMaintainanceTable={handleShowMaintainance}
        onTriggerCard={(item) => {
          handleShowProfile(item);
        }}
        onTennantTable={onHandleTenantList}
      />
    );
  if (activeComponent === "Reports") return <ReportsSection />;
  if (activeComponent === "Broadcasts")
    return <BroadCast onBackHome={handleShowHome} />;
  if (activeComponent === "Help") return <HelpSection />;
  if (activeComponent === "Logout") return <LogoutSection />;
  if (activeComponent === "General Info")
    return <PersonalInfo clases="mt-5" onBack={handleShowProfiles} />;
  if (activeComponent === "Business Information")
    return <CompanyInfo onBack={handleShowProfiles} />;
  if (activeComponent === "Payment")
    return <MainPayment onBack={handleShowProfiles} />;
  if (activeComponent === "tenantdetail")
    return (
      <MainTenantSection
        seletedTenant={seletedTenant}
        onBack={handleShowHome}
        onViewMaintainDetails={(item) => {
          setRecordId(item);
          toggleDetailMaintain(item);
        }}
        onAction={(item) => {
          handleShowProfile(item);
        }}
        toggleLeaseDetail={toggleLeaseDetail}
        onTriggerCard={handleShowProfile}
      />
    );
  if (activeComponent === "Profile")
    return (
      <ViewProfile
        onTriggerCard={(item) => {
          handleShowProfile(item);
        }}
        onBack={handleShowHome}
      />
    );
  if (activeComponent === "MaintainanceDetails")
    return <DetailMain recordId={recordId._id} onBack={handleShowHome} />;
  if (activeComponent === "createLease")
    return <CreateMain onBack={handleShowHome} />;
  // if (activeComponent === "MaintainanceDetails")
  //   return <DetailMain recordId={recordId._id} onBack={handleShowHome} />;
  if (activeComponent === "detailLease")
    return (
      <DetailLeaseMain
        onBack={handleShowHome}
        showDetailStatus={showDetail}
        recordId={recordLeaseId}
        onViewDetailsMaintain={(item) => {
          setRecordId(item);
          toggleDetailMaintain(item);
        }}
        onEditLease={(leaseDetails) => {
          toggleCreate();
          dispatch(LeaseDataAction.LeaseDetailAction(leaseDetails));
        }}
        onMaintainancePage={handleShowMaintainance}
      />
    );
  if (activeComponent === "PropertyDetails")
    return (
      <MainSection
        propertyId={propertyId}
        onBack={handleShowHome}
        onViewDetailsMaintain={(item) => {
          setRecordId(item);
          toggleDetailMaintain(item);
        }}
        onMaintainancePage={handleShowMaintainance}
        toggleLeaseDetail={toggleLeaseDetail}
        onCreateLease={onHandleLease}
      />
    );

  return null; // Default case (if no activeComponent matches)
};

export default RightSection;
